let data = null;

export function getCrossRequestDataOnce() {
  const temporary = data;
  data = null;
  return temporary;
}

export function setCrossRequestData(_data) {
  data = _data;
}
